import TextField from "@mui/material/TextField";
import { makeStyles } from "@mui/styles";

const useStyles = (error, borderColor) =>
  makeStyles({
    root: {
      "& label.Mui-focused": {
        color: error && "#B00020",
        position: "absolute",
        left: "-0.625rem",
        transform: "translate(14px,-7px)!important",
        fontSize: "12px",
        paddingLeft: "0.2rem",
        backgroundColor: "#fff",
      },
      "& .MuiInput-underline:after": {
        borderBottomColor: error && "#B00020",
      },
      "& .MuiOutlinedInput-root": {
        "& fieldset": {
          padding: "0px",
          borderColor: error ? "#B00020" : borderColor,
        },
        "&.Mui-focused fieldset": {
          borderColor: error && "#B00020",
        },
      },
    },
  });

function Field({
  label,
  error = false,
  helperText,
  endIcon,
  borderColor,
  width = "343px",
  variant = "outlined",
  sx,
  inputStyle,
  startIcon,
}) {
  const classes = useStyles(error, borderColor)();
  return (
    <TextField
      className={classes.root}
      label={label}
      
      variant={variant}
      error={error}
      helperText={error ? helperText : ""}
      InputLabelProps={{
        style: {
          lineHeight: "1",
          transform: "translate(14px,10px)",
        },
      }}
      inputProps={{
        style: {
          width: "100%",
          borderRadius: "3px",
          height: "36.28px",
          minHeight: "0px",
          padding: "0px",
          fontWeight: "400",
          fontSize: "14px",
          lineHeight: "20px",
          color: "#000",
          caretColor: error ? "#000" : "#255CCE",
          typography: "body2",
          ...inputStyle,
        },
      }}
      InputProps={{
        endAdornment: endIcon,
        sx: { minHeight: "46px" },
        startAdornment: startIcon,
      }}
      sx={{
        borderRadius: "4px",
        width: width,
        maxHeight: "36.28px",
        "& .MuiOutlinedInput-root ": {
          height: "36.28px",
          minHeight: "36.28px !important",
        },
        ...sx,
      }}
    />
  );
}

export default Field;
